// import React, { useState } from 'react'
// import { Col, Container, Row } from 'react-bootstrap'
// import Cookies from 'js-cookie'
// import toast from 'react-hot-toast'
// import axios from 'axios'

// const CreateUser = () => {
//   const [password, setPassword] = useState('')
//   const [confirmPassword, setConfirmPassword] = useState('')
//   const [displayedPassword, setDisplayedPassword] = useState('')
//   const [showPassword, setShowPassword] = useState(false)
//   const [user, setUser] = useState({
//     name: '',
//     email: '',
//     password: '',
//     user_type: '',
//   })

//   const handleChange = (e) => {
//     console.log(`Field changed: ${e.target.name}, New Value: ${e.target.value}`)
//     setUser({ ...user, [e.target.name]: e.target.value })
//   }
//   const handleFormSubmit = async (e) => {
//     e.preventDefault()

//     console.log('Form submission started.')
//     console.log('Current user data:', user)
//     console.log('Password:', password)
//     console.log('Confirm Password:', confirmPassword)

//     if (password !== confirmPassword) {
//       console.log('Password mismatch error.')
//       toast.error('Password do not match!')
//       return
//     }
//     const token = Cookies.get('authToken')
//     console.log('Auth Token:', token)
//     const payload = { ...user, password }
//     try {
//       const result = await axios.post(
//         BASE_URL+'/user/create',
//         payload,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       )
//       toast.success('New user created successfully!')
//       setDisplayedPassword(password)
//       console.log('User created successfully: ', result.data)
//       // window.location.reload()
//     } catch (error) {
//       const errorMessage =
//         error.response?.data?.message ||
//         error.message ||
//         'Failed to create user'
//       console.log('Error during user creation:', errorMessage)
//       toast.error(errorMessage)
//     }
//   }

//   return (
//     <>
//       <Container>
//         <div
//           className="d-flex justify-content-center"
//           style={{ paddingTop: '2rem' }}
//         >
//           <div
//             className="card p-4 shadow-lg "
//             style={{
//               width: '100%',
//               maxWidth: '400px',
//               border: 'none',
//             }}
//           >
//             <form>
//               <h2 className="text-center fw-bold mb-4 text-success">
//                 Create User
//               </h2>

//               {/* Form Fields */}
//               <Row className="mb-3">
//                 <Col>
//                   <div className="input-group">
//                     <span className="input-group-text bg-light">
//                       <i className="fa fa-user"></i>
//                     </span>
//                     <input
//                       type="name"
//                       name="name"
//                       className="form-control"
//                       placeholder="Enter Name"
//                       value={user.name}
//                       onChange={handleChange}
//                       required
//                     />
//                   </div>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col>
//                   <div className="input-group">
//                     <span className="input-group-text bg-light">
//                       <i className="fa fa-envelope"></i>
//                     </span>
//                     <input
//                       type="email"
//                       name="email"
//                       className="form-control"
//                       placeholder="Enter Email"
//                       value={user.email}
//                       onChange={handleChange}
//                       required
//                     />
//                   </div>
//                 </Col>
//               </Row>
//               <Row className="mb-4">
//                 <Col>
//                   <div className="input-group">
//                     <span className="input-group-text bg-light">
//                       <i className="fa fa-lock"></i>
//                     </span>
//                     <input
//                       type={showPassword ? 'text' : 'password'}
//                       className="form-control"
//                       value={password || ''}
//                       onChange={(e) => setPassword(e.target.value)}
//                       placeholder="Enter Password"
//                       required
//                     />
//                     <span
//                       className="input-group-text bg-white"
//                       onClick={() => setShowPassword(!showPassword)}
//                       style={{ cursor: 'pointer' }}
//                     >
//                       <i
//                         className={`fa ${
//                           showPassword ? 'fa-eye-slash' : 'fa-eye'
//                         }`}
//                       ></i>
//                     </span>
//                   </div>
//                 </Col>
//               </Row>

//               <Row className="mb-4">
//                 <Col>
//                   <div className="input-group">
//                     <span className="input-group-text bg-light">
//                       <i className="fa fa-lock"></i>
//                     </span>
//                     <input
//                       type="password"
//                       className="form-control"
//                       placeholder="Re-Enter Your Password"
//                       value={confirmPassword}
//                       onChange={(e) => setConfirmPassword(e.target.value)}
//                       required
//                     />
//                   </div>
//                 </Col>
//               </Row>

//               <Row className="mb-4">
//                 <Col>
//                   <div className="input-group">
//                     <span className="input-group-text bg-light">
//                       <i className="fa fa-list"></i>
//                     </span>
//                     <select
//                       className="form-select"
//                       name="user_type"
//                       value={user.user_type}
//                       onChange={handleChange}
//                       required
//                     >
//                       <option value="" disabled selected>
//                         Select User Type
//                       </option>
//                       <option value="ACCOUNTANT">ACCOUNTANT</option>
//                       <option value="EMPLOYEE">EMPLOYEE</option>
//                     </select>
//                   </div>
//                 </Col>
//               </Row>
//               <button
//                 type="submit"
//                 className="btn btn-success w-100"
//                 style={{
//                   height: '50px',
//                   fontSize: '18px',
//                   border: 'none',
//                 }}
//                 onClick={handleFormSubmit}
//               >
//                 Create User
//               </button>
//             </form>
//           </div>
//         </div>
//       </Container>
//       <Container
//         className="d-flex justify-content-center"
//         style={{ paddingTop: '2rem' }}
//       >
//         {/* Display Entered Password */}
//         {displayedPassword && (
//           <div className="alert alert-info mt-0">
//             <strong>Your Password is "</strong> {displayedPassword}{' '}
//             <strong>". Please note it.</strong>
//           </div>
//         )}
//       </Container>
//     </>
//   )
// }
// export default CreateUser


import React, { useState } from 'react'
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'
import axios from 'axios'
import {theme} from '../theme/theme'
import { BASE_URL } from '../constants'


const CreateUser = () => {
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [displayedPassword, setDisplayedPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [user, setUser] = useState({
    name: '',
    email: '',
    password: '',
    user_type: '',
  })

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value })
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault()

    if (password !== confirmPassword) {
      toast.error('Passwords do not match!')
      return
    }

    const token = Cookies.get('authToken')
    const payload = { ...user, password }

    try {
      const result = await axios.post(
        BASE_URL+'/user/create',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )
      toast.success('New user created successfully!')
      setDisplayedPassword(password)
      console.log('User created successfully:', result.data)
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to create user'
      toast.error(errorMessage)
    }
  }

  return (
    <>
  <Container className="pb-3" style={{fontFamily: theme.font.family }}>
  



          <Form onSubmit={handleFormSubmit}  
        className="mx-auto px-3 py-1"
        style={{
          backgroundColor: theme.colors.background,
      
        }}
          >

          <p
          className="mb-4 fw-bold"
          style={{
            color: theme.colors.primary,
            borderBottom: `2px solid ${theme.colors.secondary}`,
            paddingBottom: '8px',
            fontSize: '1.5rem',
          }}
        >
     Create User        
     </p>
            {/* Name Field */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Full Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter full name"
                value={user.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            {/* Email Field */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Email Address *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter email"
                value={user.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            {/* Password Field */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Password *</Form.Label>
              <div className="d-flex">
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <Button
                  type="button"
                  variant="light"
                  className="ms-2"
                  style={{
                    border: `1px solid ${theme.colors.border}`,
                    color: theme.colors.primary,
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                  ></i>
                </Button>
              </div>
            </Form.Group>

            {/* Confirm Password */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">
                Confirm Password *
              </Form.Label>
              <Form.Control
                type="password"
                placeholder="Re-enter password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </Form.Group>

            {/* User Type */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">User Type *</Form.Label>
              <Form.Select
                name="user_type"
                value={user.user_type}
                onChange={handleChange}
                required
              >
                <option value="">Select User Type</option>
                <option value="ACCOUNTANT">Accountant</option>
                <option value="EMPLOYEE">Employee</option>
              </Form.Select>
            </Form.Group>

            {/* Submit Button */}
            <div className="text-center">
              <Button
                type="submit"
                className="px-5 py-2 fw-semibold"
                style={{
                  backgroundColor: theme.colors.primary,
                  border: 'none',
                  color: '#fff',
                  width: '100%',
                }}
              >
                Create User
              </Button>
            </div>
          </Form>
        
      </Container>

      {/* Display password after creation */}
      <Container
        className="d-flex justify-content-center"
        style={{ paddingTop: '2rem' }}
      >
        {displayedPassword && (
          <div
            className="alert text-center"
            style={{
              backgroundColor: theme.colors.secondary,
              color: '#fff',
              width: 'fit-content',
              borderRadius: '0.5rem',
            }}
          >
            <strong>Your Password is:</strong> {displayedPassword}
            <br />
            <small>Please note it down safely.</small>
          </div>
        )}
      </Container>
    </>
  )
}

export default CreateUser
